/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'unlink': {
    width: 48,
    height: 48,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M17.2 12.4h-4.4l18.1 23.2h4.5zM22.7 29.6l-1.8 2.1c-.6.6-1.5.3-2.1-.3l-1.6-1.6c-.5-.5-.8-1.4-.2-2l2.2-2.8c-.6-.8-1.9-2.4-1.9-2.4l-2.4 3c-1.7 1.7-1.6 4.4.2 6.2l1.6 1.6c1.8 1.8 4.7 1.9 6.3.3l1.6-1.6-1.9-2.5zM24.9 17.7l1.9-1.9c.6-.6 1.5-.4 2 .2l1.6 1.6c.6.6.8 1.5.3 2.1l-2.1 2.7c.8 1 1.3 1.7 1.9 2.4l2.3-3c1.7-1.7 1.6-4.5-.3-6.3l-1.6-1.6c-1.8-1.8-4.5-1.9-6.2-.2l-1.6 2 1.8 2z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/unlink.js